<template>
  <ul
    class="col-12 col-sm-4 col-xl-2 navbar-nav align-items-center pt-2 pt-sm-4 pr-0 pl-3 guestInfo collapse show off-white"
    id="addLive"
  >
    <li class="h2 d-none d-sm-block">新增現場來賓</li>
    <li class="mt-3 d-none d-sm-block">
      <p class="h5">
        {{ date }}
        <span class="h4 font-weight-bold">{{ week }}</span>
      </p>
      <p class="display-4 text-center">{{ time }}</p>
    </li>
    <li class="px-3 mt-1 mb-3 my-sm-5">
      <div class="form-row">
        <div class="col">
          <label class="h4 d-flex justify-content-center">大人</label>
          <select
            class="custom-select custom-select-sm guest-input text-size"
            v-model="appointmentInformation.OrderAdultPeople"
          >
            <option v-for="index in 100" :key="index" :value="index-1">{{ index-1 }}</option>
          </select>
        </div>
        <div class="col">
          <label class="h4 d-flex justify-content-center">小孩</label>
          <select
            class="custom-select custom-select-sm guest-input text-size"
            v-model="appointmentInformation.OrderChildrenPeople"
          >
            <option v-for="index in 100" :key="index" :value="index-1">{{ index-1 }}</option>
          </select>
        </div>
        <div class="col">
          <label class="h4 d-flex justify-content-center">嬰兒</label>
          <select
            class="custom-select custom-select-sm guest-input text-size"
            v-model="appointmentInformation.OrderBabyPeople"
          >
            <option v-for="index in 100" :key="index" :value="index-1">{{ index-1 }}</option>
          </select>
        </div>
      </div>
    </li>
    <li class="px-3">
      <div class="form-group mb-3 mb-sm-4">
        <label class="d-flex align-items-center guest-input-box" for="guestName">
          <i class="las la-2x la-user-circle"></i>
          <input
            type="text"
            class="form-control guest-input"
            id="guestName"
            placeholder="姓氏"
            v-model="appointmentInformation.CustomerName"
          />

          <div class="form-check p-0">
            <input
              class="form-check-input d-none"
              type="radio"
              id="Mr"
              value="先生"
              checked
              v-model="appointmentInformation.CustomerGender"
            />
            <label class="form-check-label" for="Mr">
              <i
                class="las la-2x la-male"
                :class="{'dark':appointmentInformation.CustomerGender==='小姐'}"
              ></i>
            </label>
          </div>
          <div class="form-check p-0">
            <input
              class="form-check-input d-none"
              type="radio"
              id="Miss"
              value="小姐"
              v-model="appointmentInformation.CustomerGender"
            />
            <label class="form-check-label" for="Miss">
              <i
                class="las la-2x la-female"
                :class="{'dark':appointmentInformation.CustomerGender==='先生'}"
              ></i>
            </label>
          </div>
        </label>
      </div>
      <div class="form-group mb-3 mb-sm-4">
        <label class="d-flex align-items-center guest-input-box" for="guestPhone">
          <i class="las la-2x la-mobile"></i>
          <input
            type="text"
            class="form-control guest-input"
            id="guestPhone"
            placeholder="電話"
            v-model="appointmentInformation.CustomerPhone"
          />
        </label>
      </div>
      <div class="form-group roleListBox">
        <button
          type="button"
          class="btn mx-1 mb-1"
          v-for="item in roles"
          :key="item.Id"
          @click="roleid(item.Id)"
          :class="{'btnFocus':appointmentInformation.RoleId===item.Id}"
        >{{ item.BusinessRoleName }}</button>
      </div>
      <div class="form-group">
        <label for="exampleFormControlTextarea1">
          <i class="las la-2x la-comment"></i>
        </label>
        <textarea
          class="form-control"
          id="exampleFormControlTextarea1"
          rows="3"
          v-model="appointmentInformation.BusinessNote"
        ></textarea>
      </div>
    </li>
    <li class="px-3 mt-auto mb-5 w-100">
      <button type="button" class="btn btn-outline-light btn-sm btn-block" @click="send">排入</button>
    </li>
  </ul>
</template>
<script>
export default {
  data () {
    return {
      newTime: '',
      appointmentInformation: {
        RoleId: '',
        CustomerName: '',
        CustomerPhone: '',
        CustomerGender: '',
        OrderAdultPeople: 0,
        OrderChildrenPeople: 0,
        OrderBabyPeople: 0,
        BusinessNote: ''
      }
    }
  },
  computed: {
    date () {
      return `${this.newTime.getFullYear()}年${this.newTime.getMonth() +
        1}月${this.newTime.getDate()}日`
    },
    week () {
      const day = this.newTime.getDay()
      if (day === 0) {
        return '週日'
      } else if (day === 1) {
        return '週一'
      } else if (day === 2) {
        return '週二'
      } else if (day === 3) {
        return '週三'
      } else if (day === 4) {
        return '週四'
      } else if (day === 5) {
        return '週五'
      } else {
        return '週六'
      }
    },
    time () {
      var hour = this.newTime.getHours()
      hour = hour < 10 ? '0' + hour : hour
      var minute = this.newTime.getMinutes()
      minute = minute < 10 ? '0' + minute : minute
      return `${hour}:${minute}`
    },
    roles () {
      return this.$store.state.getRoleList
    }
  },
  methods: {
    updTime () {
      var date = new Date()
      setTimeout(() => {
        this.updTime()
      }, 1000)
      this.newTime = date
    },
    roleid (id) {
      this.appointmentInformation.RoleId = id
    },
    send () {
      const vm = this
      const d = this.appointmentInformation
      if (d.OrderAdultPeople === 0 && d.OrderBabyPeople === 0 && d.OrderChildrenPeople === 0) {
        vm.$swal({
          position: 'top-end',
          background: '#F7ECEB',
          icon: 'warning',
          title: '請選擇人數哦~',
          showConfirmButton: false,
          toast: true,
          timer: 3000,
          timerProgressBar: true,
          onOpen: toast => {
            toast.addEventListener('mouseenter', vm.$swal.stopTimer)
            toast.addEventListener('mouseleave', vm.$swal.resumeTimer)
          }
        })
      } else if (d.CustomerName === '' || d.CustomerPhone === '') {
        vm.$swal({
          position: 'top-end',
          background: '#F7ECEB',
          icon: 'warning',
          title: '請填寫姓名或手機號碼哦~',
          showConfirmButton: false,
          toast: true,
          timer: 3000,
          timerProgressBar: true,
          onOpen: toast => {
            toast.addEventListener('mouseenter', vm.$swal.stopTimer)
            toast.addEventListener('mouseleave', vm.$swal.resumeTimer)
          }
        })
      } else if (d.CustomerPhone.length < 10) {
        vm.$swal({
          position: 'top-end',
          background: '#F7ECEB',
          icon: 'error',
          title: '手機號碼不正確哦~',
          showConfirmButton: false,
          toast: true,
          timer: 3000,
          timerProgressBar: true,
          onOpen: toast => {
            toast.addEventListener('mouseenter', vm.$swal.stopTimer)
            toast.addEventListener('mouseleave', vm.$swal.resumeTimer)
          }
        })
      } else if (d.CustomerGender === '') {
        vm.$swal({
          position: 'top-end',
          background: '#F7ECEB',
          icon: 'question',
          title: '先生還是小姐呢?',
          showConfirmButton: false,
          toast: true,
          timer: 3000,
          timerProgressBar: true,
          onOpen: toast => {
            toast.addEventListener('mouseenter', vm.$swal.stopTimer)
            toast.addEventListener('mouseleave', vm.$swal.resumeTimer)
          }
        })
      } else if (d.RoleId === '') {
        vm.$swal({
          position: 'top-end',
          background: '#F7ECEB',
          icon: 'warning',
          title: '還沒選要預約的對象哦~',
          showConfirmButton: false,
          toast: true,
          timer: 3000,
          timerProgressBar: true,
          onOpen: toast => {
            toast.addEventListener('mouseenter', vm.$swal.stopTimer)
            toast.addEventListener('mouseleave', vm.$swal.resumeTimer)
          }
        })
      } else {
        const url = 'http://imrebooksystem.rocket-coding.com/Dashboard/CreateLiveBook'
        vm.axios.post(url, vm.appointmentInformation)
          .then(function (res) {
            if (res.data === '預約成功') {
              vm.$swal({
                position: 'top-end',
                background: '#F7ECEB',
                icon: 'success',
                title: '預約成功',
                showConfirmButton: false,
                toast: true,
                timer: 3000,
                timerProgressBar: true,
                onOpen: toast => {
                  toast.addEventListener('mouseenter', vm.$swal.stopTimer)
                  toast.addEventListener('mouseleave', vm.$swal.resumeTimer)
                }
              })
              vm.$store.dispatch('BusinessUser')
              vm.appointmentInformation = {
                RoleId: '',
                CustomerName: '',
                CustomerPhone: '',
                CustomerGender: '',
                OrderAdultPeople: 0,
                OrderChildrenPeople: 0,
                OrderBabyPeople: 0,
                BusinessNote: ''
              }
            } else {
              vm.$swal({
                position: 'top-end',
                background: '#F7ECEB',
                icon: 'error',
                title: res.data,
                showConfirmButton: false,
                toast: true,
                timer: 3000,
                timerProgressBar: true,
                onOpen: toast => {
                  toast.addEventListener('mouseenter', vm.$swal.stopTimer)
                  toast.addEventListener('mouseleave', vm.$swal.resumeTimer)
                }
              })
            }
          })
          .catch(error => console.error(error))
      }
    }
  },
  created () {
    this.updTime()
    this.$store.dispatch('BusinessUser')
  }
}
</script>

<style lang="scss">
.guestInfo {
  background-color: #636780;
}
.guest-input-box {
  border-bottom: 1px solid #dadbe6;
  padding-bottom: 5px;
}
.guest-input {
  background-color: #636780;
  border: 0;
  color: #f0f1f7;
  background: #636780;
}
.guest-input::-webkit-input-placeholder {
  color: #f0f1f7;
}
.guest-input:focus {
  background-color: #636780;
  color: #f0f1f7;
}
.text-size {
  font-size: 2rem;
}
.roleListBox {
  width: 100%;
  height: 120px;
  overflow-y: auto;
  .btn {
    border: 1px solid #f0f1f7;
    color: #f0f1f7;
    transition: 1s;
  }
  .btn:hover{
    background-color: #f0f1f7;
    color: #545871;
    border: 1px solid transparent;
    transition: 1s;
  }
  .btnFocus{
    background-color: #f0f1f7;
    color: #545871;
    border: 1px solid transparent;
    transition: 1s;
  }
}
.roleListBox::-webkit-scrollbar {
  width: 0 !important;
}
.dark {
  color: #9597a6;
}
@media (max-width: 767.98px) {
  .guestInfo {
    height: 30%;
    overflow-y: auto;
    label {
      font-size: 10px;
    }
  }
  .guestList {
    height: 70%;
    list-style: none;
  }
}
</style>
